import { tss } from "tss-react/mui";
import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		position: 'relative',
	},
	container: {
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 19,
		paddingTop: 48,
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 24,
			paddingTop: 40,
		}
	},
	title: {
		color: theme.palette.tertiary.main,
		fontSize: 35,
		fontWeight: 700,
		letterSpacing: '0.15px',
		lineHeight: '32px',
		marginBottom: 0,
		'& strong': {
			color: theme.palette.primary.main,
		},
		[theme.breakpoints.down('md')]: {
			fontSize: 23.7,
			lineHeight: '31px',
			fontWeight: 700,
			letterSpacing: ' 0.15px',
			marginBottom: 0,
		}
	},
	informationContainer: {
		padding: '115px 70px',
		[theme.breakpoints.down('md')]: {
			padding: '40px 16px',

		}
	},
	dateAndAuthorContainer: {
		marginBottom: 32,
		[theme.breakpoints.down('md')]: {
			marginBottom: 24,
		}
	},
	dateAndAuthor: {
		color: '#8892A0',
		fontSize: 14,
		fontWeight: 400,
		lineHeight: '17px',
		'&:first-child': {
			textDecoration: 'underline',
		},
		[theme.breakpoints.down('md')]: {
			fontSize: 14,
			lineHeight: "17px",
		}
	},
	description: {
		fontSize: 18,
		lineHeight: '23px',
	},
	imageFeatured: {
		display: 'block',
		minHeight: 417,
		marginBottom: 32,
		objectFit: "cover",
		width: "100%",
		[theme.breakpoints.down('md')]: {
			marginBottom: 16,
			minHeight: 248,
			objectFit: 'cover',
		}
	},
	breadCrumbItem: {
		fontWeight: 400,
	},
}))